export const state = {
    financialApplications: {},
    isLoading: false,
    currentProductId: null,
    financialApplicationPerPage: 10,
    totalRecords: 10,
    activePage: 1,
    addOns: [],
    financialApplicationList: financialApplicationNamespace =>
      Object.values(financialApplicationNamespace.financialApplications)
        .sort((a, b) => {
          if (a.createdAt > b.createdAt) {
            return 1
          } else if (a.createdAt < b.createdAt) {
            return -1
          }

          return 0
        })
        .slice(0, financialApplicationNamespace.financialApplicationPerPage)
  }
